<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по логину или наименованию"
      :skeleton="skeleton"
      :data="data"
      dense
      @change="onChangeDebounced"
    />
    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          :parent_mode="true"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          model="Roadmap"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.passport_type"
          :skeleton="skeleton"
          :options="typeOptions"
          item-value="value"
          item-text="text"
          $type="select"
          :return-object="false"
          label="Тип паспорта"
          :disabled="true"
          @change="onChangeDebounced"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompletePassportList
          v-model="form.status"
          :skeleton="skeleton"
          :options="statuses"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Статус"
          @change="onChangeDebounced"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompletePassportList
          v-model="form.is_active"
          :skeleton="skeleton"
          :options="stateOptions"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Состояние"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BAutocompletePassportList from '@/components/forms/BAutocompleteCommon/BAutocompletePassportList.vue'
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldAte from '@/components/forms/BTextFieldAte.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'

const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  passport_type: 'school',
  status: void 0,
  is_active: true,
  publish_date: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

const STATUS_OPTIONS = [
  { text: 'Любой', value: null },
  { text: 'Не приступал', value: 'not_started' },
  { text: 'В работе', value: 'in_progress' },
  { text: 'Сдано', value: 'submitted' },
]

const STATE_OPTIONS = [
  { text: 'Активный', value: 'true' },
  { text: 'Все', value: null },
  { text: 'Не активный', value: 'false' },
]

const TYPE_OPTIONS = [
  { text: 'ОО', value: 'school' },
  { text: 'Регионы', value: 'region' },
  { text: 'Муниципальные образования', value: 'municipalitie' },
]

export default {
  name: 'FormDataFilter',
  components: {
    BListFilter,
    BAutocompletePassportList,
    BTextFieldAte,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    statuses: STATUS_OPTIONS,
    stateOptions: STATE_OPTIONS,
    typeOptions: TYPE_OPTIONS,
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
  },
}
</script>
